import SpaceTypo from "@/models/enums/space-typo";
import { ShellValidationListboxItem } from "./shell-validation-item";

const validationsTypes: ShellValidationListboxItem[] = [
    {
        label: "Appartement",
        keyName: SpaceTypo.InterieurAppartement,
        color: "#FF7F00",
        description: "Comptabilisé dans SHAB"
    },
    {
        label: "Ascenseur",
        keyName: SpaceTypo.Ascenseur,
        color: "#8B0000",
        description: "Déduit de SDP, ST et SHOB"
    },
    {
        label: "CirculationH",
        keyName: SpaceTypo.CirculationH,
        color: "#9ACCFF",
        description: ""
    },
    {
        label: "Commerce",
        keyName: SpaceTypo.Commerce,
        color: "#800080",
        description: "Comptabilisé dans SU "
    },
    {
        label: "Escalier",
        keyName: SpaceTypo.Escalier,
        color: "#00008B",
        description: "Déduit de SDP, ST et SHOB"
    },
    {
        label: "Extérieure",
        keyName: SpaceTypo.Exterieure,
        color: "#90EE90",
        description: "Comptabilisé dans SHOB"
    },
    {
        label: "Gaine",
        keyName: SpaceTypo.Gaine,
        color: "#008000",
        description: "Déduit de SDP, ST et SHOB"
    },
    {
        label: "Local",
        keyName: SpaceTypo.Local,
        color: "#E066FF",
        description: "Déduit de SDP"
    },
    {
        label: "Parking",
        keyName: SpaceTypo.Parking,
        color: "#420042",
        description: "Déduit de SDP"
    },
    {
        label: "Vide sur Hall",
        keyName: SpaceTypo.VideSurHall,
        color: "#595959",
        description: "Déduit de SDP, ST et SHOB"
    },
    {
        label: "SU extérieure",
        keyName: SpaceTypo.SUexterieure,
        color: "#FFCC00",
        description: "SU extérieure"
    },
    {
        label: "Aucun",
        keyName: SpaceTypo.Aucun,
        color: "#537db1",
        description: "Non comptabilisé dans SHOB"
    }
];

export default validationsTypes;